export default {
	iconSize: 14,
};
